import type { inferRouterInputs, inferRouterOutputs } from '@sweetistics/trpc-server';
import { trpc } from '@/lib/trpc/client';
import type { AppRouter } from '@/types/app-router';

type SocialRouter = NonNullable<(typeof trpc)['social']>;

type UpdateCookiesProcedure = NonNullable<SocialRouter['updateCookies']>;
type DeleteCookiesProcedure = NonNullable<SocialRouter['deleteCookies']>;

type UpdateCookiesOptions = Parameters<UpdateCookiesProcedure['useMutation']>[0];
type DeleteCookiesOptions = Parameters<DeleteCookiesProcedure['useMutation']>[0];

export type UpdateCookiesInput = inferRouterInputs<AppRouter>['social']['updateCookies'];
export type UpdateCookiesResult = inferRouterOutputs<AppRouter>['social']['updateCookies'];
export type DeleteCookiesResult = inferRouterOutputs<AppRouter>['social']['deleteCookies'];

export function useUpdateSocialCookies(options?: UpdateCookiesOptions) {
  return trpc.social.updateCookies.useMutation(options);
}

export function useDeleteSocialCookies(options?: DeleteCookiesOptions) {
  return trpc.social.deleteCookies.useMutation(options);
}
